import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'CashFlowDocumentType',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getCashFlowDocumentTypeSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateCashFlowDocumentType(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getCashFlowDocumentType() {
  return async () => {
    try {
      const response = await get(`CashFlowDocumentType`);
      if (response.status) {
        dispatch(slice.actions.getCashFlowDocumentTypeSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addCashFlowDocumentType(body) {
  return async () => {
    try {
      const response = await post(`CashFlowDocumentType`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateCashFlowDocumentType(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateCashFlowDocumentType(body) {
  return async () => {
    try {
      const response = await put(`CashFlowDocumentType`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateCashFlowDocumentType(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
